import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  v2ListStartupDocumentVersionsOptions,
  v2StartupGetAiReadsOptions,
  v2StartupGetEmailUpdatesOptions,
  v2StartupGetEmailUpdatesQueryKey,
  v2StartupListFollowersOptions,
  v2StartupListFollowersQueryKey,
  v2StartupRemoveEmailUpdateMutation,
  v2StartupRemoveFollowerMutation,
} from '@workspace/api-backend/react-query'

export function useAiReadsQuery(startupId: string) {
  return useQuery(v2StartupGetAiReadsOptions({ path: { startupId } }))
}

export function useEmailUpdatesQuery(startupId: string) {
  return useQuery(v2StartupGetEmailUpdatesOptions({ path: { startupId } }))
}

export function useRemoveEmailUpdate(startupId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    ...v2StartupRemoveEmailUpdateMutation(),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: v2StartupGetEmailUpdatesQueryKey({ path: { startupId } }),
      }),
  })
}

export function useFollowersQuery(startupId: string) {
  return useQuery(v2StartupListFollowersOptions({ path: { startupId } }))
}

export function useRemoveFollower(startupId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    ...v2StartupRemoveFollowerMutation(),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: v2StartupListFollowersQueryKey({ path: { startupId } }),
      }),
  })
}

export function useDocumentVersionsQuery(startupId: string) {
  return useQuery(v2ListStartupDocumentVersionsOptions({ path: { startupId } }))
}
